import React, { useState, useEffect } from "react"
import { Box, Button, Typography, IconButton } from "@mui/joy"
import { useFormContext, useWatch } from "react-hook-form"
import { useFormatter } from "src/mtska-frontend-app-component/utils"
import { useTranslation } from "react-i18next"
import { useDrawer } from "../Drawer"

const WidgetSpeechReader = props => {

    const [campaign, setCampaign] = useState()
    const [activityOutcomes, setActivityOutcomes] = useState()

    const campaignlead = useWatch({
        control: props.control,
        name: 'campaignlead'
    });

    useEffect(() => {
        console.info('campaign lead ricevuto', campaignlead)
        if (!campaignlead) return;

        setCampaign(campaignlead?.data?.campaign)
        setActivityOutcomes(campaignlead?.data?.campaign?.activityOutcomes ?? [])
    }, [campaignlead])

    // const { t } = useTranslation()
    // const [currentPage, setCurrentPage] = useState(1)

    // // Mock data per il disco di vendita
    // const salesDiskData = {
    //     title: "Disco di Vendita - Promozione Luglio Green",
    //     script: {
    //         introduction: "Buongiorno/Buonasera, sono Mario Rossi di Gelsia, la ringrazio per il tempo che mi dedica.",
    //         promotion: "La contatto in merito alla nuova promozione 'Luglio Green' dedicata a clienti selezionati come lei.",
    //         offer: "Abbiamo riservato un'offerta esclusiva per il passaggio a una fornitura luce e gas più conveniente e sostenibile.",
    //         advantages: [
    //             "Risparmio garantito rispetto alla tariffa attuale",
    //             "100% energia verde certificata",
    //             "Nessun costo di attivazione",
    //             "Assistenza dedicata 24/7",
    //             "Sconto del 15% per i primi 6 mesi"
    //         ]
    //     },
    //     pages: [
    //         {
    //             title: "Pagina 1 - Presentazione",
    //             content: "Benvenuto nella presentazione della promozione Luglio Green. Questa offerta esclusiva è riservata a clienti selezionati.",
    //             type: "introduction"
    //         },
    //         {
    //             title: "Pagina 2 - Vantaggi",
    //             content: "Scopri tutti i vantaggi della nostra offerta: risparmio garantito, energia 100% verde e nessun costo di attivazione.",
    //             type: "advantages"
    //         },
    //         {
    //             title: "Pagina 3 - Dettagli Tecnici",
    //             content: "I dettagli tecnici dell'offerta includono: potenza impegnata 3 kW, fornitura monoraria, certificazione energia rinnovabile.",
    //             type: "technical"
    //         },
    //         {
    //             title: "Pagina 4 - Modulo Adesione",
    //             content: "Completa il modulo di adesione per usufruire subito della promozione Luglio Green.",
    //             type: "form"
    //         }
    //     ]
    // }

    // const totalPages = salesDiskData.pages.length

    // const prevPage = () => {
    //     if (currentPage > 1) setCurrentPage(currentPage - 1)
    // }

    // const nextPage = () => {
    //     if (currentPage < totalPages) setCurrentPage(currentPage + 1)
    // }

    // const currentPageData = salesDiskData.pages[currentPage - 1]

    return (
        <Box className={"form-element form-activity-editor " + props.className}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    width: "100%"
                }}
            >
                <Box>
                    <Typography level="h4" mb={3}>{campaign?.name}</Typography>
                    <Typography level="p" mb={1}>Disco vendita</Typography>
                    <Box style={{border:'1px solid var(--neutral-300)', padding:'20px', height:'400px', width:'100%', borderRadius:'12px'}}>{campaign?.salesDisk}</Box>
                </Box>
                {/* 
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button variant="outlined">Scarica PDF</Button>
                </Box> 
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%"
                    }}
                >
                    <Typography>{t("Contatto Telefonico")}</Typography>
                </Box>
                

                <Box
                    sx={{
                        border: "1px solid #ddd",
                        borderRadius: "12px",
                        padding: 3,
                        backgroundColor: "#fff"
                    }}
                >
                    <Typography paragraph>
                        {salesDiskData.script.introduction}
                    </Typography>
                    <Typography paragraph>
                        {salesDiskData.script.promotion}
                    </Typography>
                    <Typography paragraph>
                        {salesDiskData.script.offer}
                    </Typography>
                    <Typography fontWeight="bold" paragraph>
                        VANTAGGI PRINCIPALI:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mt: 1 }}>
                        {salesDiskData.script.advantages.map((advantage, index) => (
                            <Typography key={index} component="li">
                                {advantage}
                            </Typography>
                        ))}
                    </Box>
                </Box>

                <Box>
                    <Box
                        sx={{
                            border: "1px solid #ddd",
                            borderRadius: "12px",
                            padding: 4,
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            minHeight: 280
                        }}
                    >
                        <Typography level="h6" sx={{ fontWeight: 600 }}>
                            {currentPageData.title}
                        </Typography>
                        <Typography sx={{ textAlign: "center" }}>
                            {currentPageData.content}
                        </Typography>
                        <Typography sx={{ opacity: 0.7, fontSize: "sm" }}>
                            Tipo: {currentPageData.type}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            mt: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <Button variant="outlined" onClick={prevPage} disabled={currentPage === 1}>
                            Precedente
                        </Button>

                        <Typography>
                            Pagina {currentPage} di {totalPages}
                        </Typography>

                        <Button variant="outlined" onClick={nextPage} disabled={currentPage === totalPages}>
                            Successiva
                        </Button>
                    </Box>
                </Box>
                */}
            </Box>
        </Box>
    )
}

export default WidgetSpeechReader